import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Grid } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "../../constants/ThemeConstant";
import utils from "../../utils";
import {
  isCompanyAdminEquivalent,
  isContractAdminEquivalent,
  isDelegationBlockedForRole,
  isCxoAdminEquivalent,
  canonicalRole,
} from "../../utils/roleUtils";
import { onMobileNavToggle } from "../../redux/actions/Theme";
import {
  SettingOutlined,
  UserAddOutlined,
  ScheduleOutlined,
  ApartmentOutlined,
  BankOutlined,
  CloudServerOutlined,
  AuditOutlined,
  FileTextOutlined,
  UnorderedListOutlined,
  TeamOutlined,
  LinkOutlined,
  UserOutlined,
  CalendarOutlined,
  FieldTimeOutlined,
  CheckCircleOutlined,
  DashboardOutlined,
  BarChartOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "../../configs/AppConfig";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const superUserNavTree = [
  {
    key: "analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    title: "sidenav.analytics",
    icon: BarChartOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "analytics-obligation-overview",
        path: `${APP_PREFIX_PATH}/analytics/obligation-overview`,
        title: "sidenav.obligation-overview",
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-reports",
        path: `${APP_PREFIX_PATH}/analytics/reports`,
        title: "sidenav.analytics-reports",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "obligation-management-section",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.obligation-management-section",
    icon: UnorderedListOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "my-obligation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.my-obligation",
        icon: UnorderedListOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "my-obligation-time-based",
            path: `${APP_PREFIX_PATH}/my-obligation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "my-obligation-event-based",
            path: `${APP_PREFIX_PATH}/my-obligation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "instance-obligation",
        path: `${APP_PREFIX_PATH}/instance-obligation`,
        title: "sidenav.compliance-view-task",
        icon: FileTextOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "auditor-action",
        path: `${APP_PREFIX_PATH}/auditing-action`,
        title: "sidenav.auditor-action",
        icon: AuditOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "compliance-approval",
        path: `${APP_PREFIX_PATH}/compliance-approval`,
        title: "sidenav.compliance-approval",
        icon: CheckCircleOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "delegation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.delegation",
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "delegation-time-based",
            path: `${APP_PREFIX_PATH}/delegation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "delegation-event-based",
            path: `${APP_PREFIX_PATH}/delegation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "due-date-manager",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.due-date-manager",
        icon: CalendarOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "due-date-manager-time-based",
            path: `${APP_PREFIX_PATH}/due-date-manager/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "due-date-manager-event-based",
            path: `${APP_PREFIX_PATH}/due-date-manager/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "application-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.applicaiton-settings",
    icon: SettingOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "settings",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.settings",
        icon: SettingOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "company-management",
            path: `${APP_PREFIX_PATH}/company-management`,
            title: "sidenav.company-management",
            icon: BankOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "user-management",
            path: `${APP_PREFIX_PATH}/user-management`,
            title: "sidenav.user-management",
            icon: UserAddOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "client-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.client-settings",
    icon: ScheduleOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "company-settings",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.company-settings",
        icon: CloudServerOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "team-management",
            path: `${APP_PREFIX_PATH}/team-management`,
            title: "sidenav.project-management",
            icon: ApartmentOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "cxo-management",
            path: `${APP_PREFIX_PATH}/cxo-management`,
            title: "sidenav.cxo-management",
            icon: AuditOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "contract-management",
            path: `${APP_PREFIX_PATH}/contract-management`,
            title: "sidenav.contract-management",
            icon: FileTextOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "obligation-management",
            path: `${APP_PREFIX_PATH}/obligation-management`,
            title: "sidenav.obligation-management",
            icon: UnorderedListOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "team-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.team-settings",
    icon: TeamOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "team-settings-menu",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.team-settings",
        icon: TeamOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "obligation-mapping",
            path: `${APP_PREFIX_PATH}/obligation-mapping`,
            title: "sidenav.obligation-mapping",
            icon: LinkOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "team-obligation-user",
            path: `${APP_PREFIX_PATH}/team-obligation-user`,
            title: "sidenav.team-obligation-user",
            icon: UserOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
];

const userNavTree = [
  {
    key: "analytics",
    path: `${APP_PREFIX_PATH}/analytics`,
    title: "sidenav.analytics",
    icon: BarChartOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "analytics-obligation-overview",
        path: `${APP_PREFIX_PATH}/analytics/obligation-overview`,
        title: "sidenav.obligation-overview",
        /** Match the superUserNavTree icon — previously this was BarChartOutlined (same as the Reports row below it), which made the icon visually identical for non-super-user roles. */
        icon: DashboardOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "analytics-reports",
        path: `${APP_PREFIX_PATH}/analytics/reports`,
        title: "sidenav.analytics-reports",
        icon: BarChartOutlined,
        breadcrumb: true,
        submenu: [],
      },
    ],
  },
  {
    key: "obligation-management-section",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.obligation-management-section",
    icon: UnorderedListOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "my-obligation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.my-obligation",
        icon: UnorderedListOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "my-obligation-time-based",
            path: `${APP_PREFIX_PATH}/my-obligation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "my-obligation-event-based",
            path: `${APP_PREFIX_PATH}/my-obligation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
      {
        key: "instance-obligation",
        path: `${APP_PREFIX_PATH}/instance-obligation`,
        title: "sidenav.compliance-view-task",
        icon: FileTextOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "auditor-action",
        path: `${APP_PREFIX_PATH}/auditing-action`,
        title: "sidenav.auditor-action",
        icon: AuditOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "compliance-approval",
        path: `${APP_PREFIX_PATH}/compliance-approval`,
        title: "sidenav.compliance-approval",
        icon: CheckCircleOutlined,
        breadcrumb: true,
        submenu: [],
      },
      {
        key: "delegation",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.delegation",
        icon: UserOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "delegation-time-based",
            path: `${APP_PREFIX_PATH}/delegation/time-based`,
            title: "sidenav.change-due-date-time",
            icon: FieldTimeOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "delegation-event-based",
            path: `${APP_PREFIX_PATH}/delegation/event-based`,
            title: "sidenav.change-due-date-events",
            icon: CalendarOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
];

/** PROJECT-ADMIN: same as end users for obligations/analytics, plus team-level items only — not Client/Company settings (company admin). */
const teamNavTree = [
  ...userNavTree,
  {
    key: "team-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.team-settings",
    icon: TeamOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "team-settings-menu",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.team-settings",
        icon: TeamOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "obligation-mapping",
            path: `${APP_PREFIX_PATH}/obligation-mapping`,
            title: "sidenav.obligation-mapping",
            icon: LinkOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "team-obligation-user",
            path: `${APP_PREFIX_PATH}/team-obligation-user`,
            title: "sidenav.team-obligation-user",
            icon: UserOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
];

/** COMPANY-ADMIN / CONTRACT-ADMIN: no Application Settings (company/user management); use super-user nav for that. */
const companyNavTree = [
  ...userNavTree,
  {
    key: "client-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.client-settings",
    icon: ScheduleOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "company-settings",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.company-settings",
        icon: CloudServerOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "team-management",
            path: `${APP_PREFIX_PATH}/team-management`,
            title: "sidenav.project-management",
            icon: ApartmentOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "cxo-management",
            path: `${APP_PREFIX_PATH}/cxo-management`,
            title: "sidenav.cxo-management",
            icon: AuditOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "contract-management",
            path: `${APP_PREFIX_PATH}/contract-management`,
            title: "sidenav.contract-management",
            icon: FileTextOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "obligation-management",
            path: `${APP_PREFIX_PATH}/obligation-management`,
            title: "sidenav.obligation-management",
            icon: UnorderedListOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
  {
    key: "team-settings",
    path: `${APP_PREFIX_PATH}/`,
    title: "sidenav.team-settings",
    icon: TeamOutlined,
    breadcrumb: true,
    submenu: [
      {
        key: "team-settings-menu",
        path: `${APP_PREFIX_PATH}/`,
        title: "sidenav.team-settings",
        icon: TeamOutlined,
        breadcrumb: true,
        submenu: [
          {
            key: "obligation-mapping",
            path: `${APP_PREFIX_PATH}/obligation-mapping`,
            title: "sidenav.obligation-mapping",
            icon: LinkOutlined,
            breadcrumb: true,
            submenu: [],
          },
          {
            key: "team-obligation-user",
            path: `${APP_PREFIX_PATH}/team-obligation-user`,
            title: "sidenav.team-obligation-user",
            icon: UserOutlined,
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
];

/** CONTRACT-ADMIN cannot access Contract / CXO / Team management; strip from company-admin nav. */
const CONTRACT_ADMIN_HIDDEN_CLIENT_SETTING_KEYS = new Set([
  "team-management",
  "contract-management",
  "cxo-management",
]);
const removeContractAdminRestrictedClientSettingsFromNav = (tree) =>
  tree.map((menu) => ({
    ...menu,
    submenu: (menu.submenu || []).map((sub) => ({
      ...sub,
      submenu: (sub.submenu || []).filter(
        (item) => !CONTRACT_ADMIN_HIDDEN_CLIENT_SETTING_KEYS.has(item.key)
      ),
    })),
  }));

/** Strip Delegation from Obligation Management (contract-admin + custom-user + cxo-admin). */
const removeDelegationFromNavTree = (tree) =>
  tree.map((menu) => {
    if (menu.key !== "obligation-management-section") {
      return menu;
    }
    return {
      ...menu,
      submenu: (menu.submenu || []).filter((item) => item.key !== "delegation"),
    };
  });

/** Strip Due Date Manager from Obligation Management (cxo-admin — read-only role). */
const removeDueDateManagerFromNavTree = (tree) =>
  tree.map((menu) => {
    if (menu.key !== "obligation-management-section") {
      return menu;
    }
    return {
      ...menu,
      submenu: (menu.submenu || []).filter(
        (item) => item.key !== "due-date-manager"
      ),
    };
  });

/** "Reset Archived Obligation" (formerly Auditor Review) is restricted to SUPER USER and CONTRACT ADMIN; strip it from any other role's nav. */
const removeAuditorActionFromNavTree = (tree) =>
  tree.map((menu) => {
    if (menu.key !== "obligation-management-section") {
      return menu;
    }
    return {
      ...menu,
      submenu: (menu.submenu || []).filter((item) => item.key !== "auditor-action"),
    };
  });

const projectAdminNavTree = teamNavTree;

const applyDelegationNavPolicy = (tree, effectiveRole) =>
  isDelegationBlockedForRole(effectiveRole) ? removeDelegationFromNavTree(tree) : tree;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    onMobileNavToggle,
    data,
    divisionRole,
    companyRole,
    selectedUserRole,
  } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const [navContent, setnavContent] = useState([]);

  useEffect(() => {
    const rawRole =
      divisionRole !== null
        ? divisionRole
        : companyRole !== null
          ? companyRole
          : selectedUserRole ?? data?.role ?? "USER";
    // Treat TEAM-ADMIN as PROJECT-ADMIN — same permissions/menu tree.
    const effectiveRole = canonicalRole(rawRole) || rawRole;

    if (effectiveRole === "SUPER-USER") {
      setnavContent(applyDelegationNavPolicy(superUserNavTree, effectiveRole));
    } else if (isCxoAdminEquivalent(effectiveRole)) {
      /** CXO ADMIN: same nav surface as COMPANY ADMIN, minus Delegation
       * (handled by applyDelegationNavPolicy) and Due Date Manager.
       * Auditor Action stays stripped (same as plain Company Admin). */
      const base = removeDueDateManagerFromNavTree(
        removeAuditorActionFromNavTree(companyNavTree)
      );
      setnavContent(applyDelegationNavPolicy(base, effectiveRole));
    } else if (isCompanyAdminEquivalent(effectiveRole)) {
      /** "Reset Archived Obligation" stays for Contract Admin; plain Company Admin gets it stripped. */
      const isContractAdmin = isContractAdminEquivalent(effectiveRole);
      const base = isContractAdmin
        ? removeContractAdminRestrictedClientSettingsFromNav(companyNavTree)
        : removeAuditorActionFromNavTree(companyNavTree);
      setnavContent(applyDelegationNavPolicy(base, effectiveRole));
    } else if (effectiveRole === "PROJECT-ADMIN") {
      setnavContent(
        applyDelegationNavPolicy(removeAuditorActionFromNavTree(projectAdminNavTree), effectiveRole)
      );
    } else {
      setnavContent(
        applyDelegationNavPolicy(removeAuditorActionFromNavTree(userNavTree), effectiveRole)
      );
    }
  }, [data, divisionRole, companyRole, selectedUserRole]);

  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false);
    }
  };
  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      className={hideGroupTitle ? "hide-group-title" : "tt"}
    >
      {navContent.map((menu) =>
        menu.submenu.length > 0 ? (
          <Menu.ItemGroup
            key={menu.key}
            title={setLocale(localization, menu.title)}
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  key={subMenuFirst.key}
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item
                      key={subMenuSecond.key}
                      style={{ paddingLeft: "34px" }}
                    >
                      <Link
                        to={subMenuSecond.path}
                        onClick={() => closeMobileNav()}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {subMenuSecond.icon ? (
                          <Icon type={subMenuSecond?.icon} />
                        ) : null}
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? <Icon type={subMenuFirst.icon} /> : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link
                    onClick={() => closeMobileNav()}
                    to={subMenuFirst.path}
                  />
                </Menu.Item>
              )
            )}
          </Menu.ItemGroup>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? (
              <Link onClick={() => closeMobileNav()} to={menu.path} />
            ) : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization, data, divisionRole, companyRole, selectedUserRole } = props;
  const [navContent, setnavContent] = useState([]);
  useEffect(() => {
    const rawRole =
      divisionRole !== null
        ? divisionRole
        : companyRole !== null
          ? companyRole
          : selectedUserRole ?? data?.role ?? "USER";
    // Treat TEAM-ADMIN as PROJECT-ADMIN — same permissions/menu tree.
    const effectiveRole = canonicalRole(rawRole) || rawRole;

    if (effectiveRole === "SUPER-USER") {
      setnavContent(applyDelegationNavPolicy(superUserNavTree, effectiveRole));
    } else if (isCxoAdminEquivalent(effectiveRole)) {
      const base = removeDueDateManagerFromNavTree(
        removeAuditorActionFromNavTree(companyNavTree)
      );
      setnavContent(applyDelegationNavPolicy(base, effectiveRole));
    } else if (isCompanyAdminEquivalent(effectiveRole)) {
      /** "Reset Archived Obligation" stays for Contract Admin; plain Company Admin gets it stripped. */
      const isContractAdmin = isContractAdminEquivalent(effectiveRole);
      const base = isContractAdmin
        ? removeContractAdminRestrictedClientSettingsFromNav(companyNavTree)
        : removeAuditorActionFromNavTree(companyNavTree);
      setnavContent(applyDelegationNavPolicy(base, effectiveRole));
    } else if (effectiveRole === "PROJECT-ADMIN") {
      setnavContent(
        applyDelegationNavPolicy(removeAuditorActionFromNavTree(projectAdminNavTree), effectiveRole)
      );
    } else {
      setnavContent(
        applyDelegationNavPolicy(removeAuditorActionFromNavTree(userNavTree), effectiveRole)
      );
    }
  }, [data, divisionRole, companyRole, selectedUserRole]);

  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navContent.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  popupClassName="top-nav-menu"
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <Link to={subMenuSecond.path} style={{ display: "flex", alignItems: "center" }}>
                        <span>
                          {setLocale(localization, subMenuSecond.title)}
                        </span>
                      </Link>
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { sideNavTheme, topNavColor } = theme;
  const { data, customeUserRole, divisionRole, companyRole, selectedUserRole } = auth;
  return {
    sideNavTheme,
    topNavColor,
    data,
    customeUserRole,
    divisionRole,
    companyRole,
    selectedUserRole,
  };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
